/**
 * Normalizează orice eroare API / Error / valoare necunoscută într-un string sigur pentru UI (Alert, Typography).
 * Nu expune obiecte nested ca valoare React child.
 */
export function normalizeUserFacingErrorMessage(input: unknown): string {
  if (input == null || input === '') {
    return 'A apărut o eroare. Încearcă din nou.';
  }

  if (typeof input === 'string') {
    const t = input.trim();
    return t || 'A apărut o eroare. Încearcă din nou.';
  }

  if (input instanceof Error) {
    return input.message || 'Eroare necunoscută.';
  }

  if (typeof input === 'object') {
    const o = input as Record<string, unknown>;

    if (typeof o.message === 'string' && o.message.trim()) {
      return o.message.trim();
    }

    if (typeof o.error === 'string' && o.error.trim()) {
      return o.error.trim();
    }

    if (o.error && typeof o.error === 'object' && o.error !== null) {
      const inner = (o.error as Record<string, unknown>).message;
      if (typeof inner === 'string' && inner.trim()) {
        return inner.trim();
      }
    }

    if (Array.isArray(o.details) && o.details.length > 0) {
      const first = o.details[0] as Record<string, unknown> | undefined;
      if (first && typeof first.message === 'string' && first.message.trim()) {
        return first.message.trim();
      }
    }
  }

  return 'A apărut o eroare. Încearcă din nou.';
}
